"use client";

import { useEffect } from "react";

// https://posthog.com/docs/libraries/next-js

interface PostHogProviderProps {
  children: React.ReactNode;
  userId?: string; // Optional userId for PostHog distinct_id
}

export function PostHogProvider({ children, userId }: PostHogProviderProps) {
  useEffect(() => {
    const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    const apiHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

    if (!apiKey || !apiHost) {
      return;
    }

    let isCancelled = false;

    void import("posthog-js").then(({ default: posthog }) => {
      if (isCancelled) {
        return;
      }

      // Keep core analytics, but block optional remote extensions that are
      // currently breaking production on the landing page.
      posthog.init(apiKey, {
        api_host: apiHost,
        capture_pageview: false,
        disable_external_dependency_loading: true,
        disable_session_recording: true,
        disable_surveys: true,
        disable_surveys_automatic_display: true,
        capture_dead_clicks: false,
        capture_exceptions: false,
      });

      if (userId) {
        posthog.identify(userId);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [userId]);

  return <>{children}</>;
}
